<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordocas/svgCas10bg.svg" />

    <span class="normalTheme pageInstruction" style="left: 82px; top: 128px; z-index: 2;">
      <p>Completa los globos con la opción correcta.</p>
    </span>
    <p id="tag01" class="textBase basicItem01 tagDefault">
      ¡No permitiré que las quemen!
    </p>
    <p id="tag02" class="textBase basicItem01 tagDefault">
      ¡No permitiré que las maten!
    </p>
    <p id="tag03" class="textBase basicItem01 tagDefault">
      ¡No permitiré que las lastimen!
    </p>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField01"
    />

    <p id="text01" class="textBase pageElement">
      ¡Dejen en paz a las hormigas!
    </p>
    <img
      id="serafin"
      class="pageElement hover-animation-a"
      src="/pages/img/sordocas/svgCasSerafin.svg"
    />
    <img
      id="ants"
      class="pageElement basicItem01"
      src="/pages/img/sordocas/svgCasAnts.svg"
    />
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 78px;
  top: 56px;
  z-index: -1;
}
#tag01 {
  position: absolute;
  width: 550px;
  text-align: center;
  left: 118px;
  top: 187px;
}
#tag02 {
  position: absolute;
  width: 550px;
  text-align: center;
  left: 118px;
  top: 277px;
}
#tag03 {
  position: absolute;
  width: 550px;
  text-align: center;
  left: 118px;
  top: 367px;
}
#text01 {
  position: absolute;
  left: 179px;
  top: 506px;
  font-size: 30px;
}
#inputField01 {
  position: absolute;
  width: 505px;
  height: 35px;
  left: 330px;
  top: 558px;
  z-index: 2;
}
#serafin {
  position: absolute;
  left: 130px;
  top: 537px;
}
#ants {
  position: absolute;
  left: 656px;
  top: 618px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["cas/Video 18.mp4", "cas/Video 19.mp4", "cas/Video 20.mp4", "cas/Video 21a.mp4", "cas/Video 22.mp4",],
    }
  }
}
</script>